import React from 'react';
import FMActionItem from '../../common/fm-action-item/fm-action-item';
import { ActionItemProps } from '../../../models/experiencefragments/action-item';

const FMActionItemReviewVehicleHealth = (props: ActionItemProps) => {
    const { content, requiredLabel, recommendedLabel } = props;

    if (!content) {
        return null;
    }

    return (
        <FMActionItem
            content={content}
            required={false}
            requiredLabel={requiredLabel}
            recommendedLabel={recommendedLabel}
        />
    );
};

export default FMActionItemReviewVehicleHealth;
